import { motion } from "framer-motion";
import {
  Sparkles,
  Soup,
  Leaf,
  Flower2,
  Truck,
  HeartHandshake,
  Building2,
  Boxes,
} from "lucide-react";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const ITEMS = [
  { icon: Soup, title: "Freshly made to order", span: "md:col-span-2" },
  { icon: Sparkles, title: "Authentic Japanese recipes", span: "" },
  { icon: Leaf, title: "Premium quality ingredients", span: "" },
  { icon: Flower2, title: "Beautiful presentation", span: "" },
  { icon: Truck, title: "Reliable delivery", span: "" },
  { icon: HeartHandshake, title: "Friendly service", span: "" },
  { icon: Building2, title: "Ideal for corporate catering", span: "md:col-span-2" },
  { icon: Boxes, title: "Flexible catering packages", span: "", color: "text-[#C1272D]" },
];

export const WhyChooseUs = () => (
  <section
    data-testid="why-section"
    className="bg-surface py-24 md:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
        <div>
          <span className="label-caps text-sage">Why Choose Us</span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl text-ink">
            The OKOME difference
          </h2>
        </div>
      </div>

      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-px bg-border border border-border"
      >
        {ITEMS.map((it, i) => (
          <motion.div
            key={i}
            variants={reveal}
            data-testid={`why-item-${i}`}
            className={`bg-cream p-8 md:p-10 flex flex-col gap-6 min-h-[200px] justify-between hover:bg-surface transition-colors duration-300 ${it.span}`}
          >
            <it.icon
              className="text-sage"
              size={30}
              strokeWidth={1.4}
              aria-hidden="true"
            />
            <h3 className={`font-serif text-2xl md:text-3xl leading-tight ${it.color || "text-ink"}`}>
              {it.title}
            </h3>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
